import { z } from "zod";

export const ProjectSummaryDtoSchema = z.object({
  id: z.string(),
  name: z.string(),
  wallCount: z.number().int(),
  updatedAt: z.string(),
  digest: z.string(),
  deletedAt: z.string().nullable(),
});
export type ProjectSummaryDto = z.infer<typeof ProjectSummaryDtoSchema>;

/** PUT /api/projects/:id — `project` motorun ProjectSchema'sıyla API tarafında doğrulanır. */
export const PutProjectBodySchema = z.object({
  project: z.unknown(),
  /** İstemcinin son bildiği sunucu zamanı; uyuşmazsa 409 (çakışma). İlk kayıtta boş. */
  baseUpdatedAt: z.string().optional(),
  note: z.string().max(200).optional(),
});
export type PutProjectBody = z.infer<typeof PutProjectBodySchema>;

export const PutProjectResponseSchema = z.object({ updatedAt: z.string(), digest: z.string() });
export const ConflictResponseSchema = z.object({
  error: z.string(),
  code: z.literal("CONFLICT"),
  server: z.object({ updatedAt: z.string(), digest: z.string() }),
});

export const ProjectVersionDtoSchema = z.object({
  id: z.number().int(),
  savedAt: z.string(),
  digest: z.string(),
  note: z.string().nullable(),
});
export type ProjectVersionDto = z.infer<typeof ProjectVersionDtoSchema>;

export const CreateShareBodySchema = z.object({
  expiresAt: z.string().datetime({ offset: true }).optional(),
  allowDownload: z.boolean().default(true),
});
export const ShareDtoSchema = z.object({
  token: z.string(),
  url: z.string(),
  expiresAt: z.string().nullable(),
  allowDownload: z.boolean(),
  createdAt: z.string(),
});
export type ShareDto = z.infer<typeof ShareDtoSchema>;

export const SharedProjectResponseSchema = z.object({
  project: z.unknown(),
  name: z.string(),
  allowDownload: z.boolean(),
});

export const MAX_PROJECT_BYTES = 2 * 1024 * 1024;
export const MAX_VERSIONS = 20;
/** Silinen proje bu kadar gün "Silinenler"de bekler, sonra kalıcı silinir (sürümler ve paylaşımlarıyla). */
export const TRASH_DAYS = 30;
